module.exports = __webpack_public_path__ + "static/media/MHRM09N0001.fa94d44b.svg";